import React from "react";

import Grid, { Col } from "../../components/grid/Grid";
import Section from "../../components/section/Section";
import PageLabel from "../../components/pageLabel/PageLabel";
import * as styles from "./showcaseHeader.module.css";
import { useScrollPosition, useWindowSize } from "../../utils/hooks";

const ShowcaseHeader = ({ 
  className, 
  title,
  titleHtml,
  style,
  tagline, 
  backgroundColor, 
  backgroundImage,
  backgroundAlt,
  mobileBackgroundImage,
  backgroundImageCustom,
  backgroundVideo,
  mobileNoBackgroundVideo,
  showcaseImages,
  lightOnDarkDesktop,
  backgroundGradient,
  backgroundGradientWhite,
  backgroundImageSrc,
  tag,
  caption,
  additional,
  flexFix,
  widerStrapline
}) => {
  const windowHeight = useWindowSize().height;
  const windowWidth = useWindowSize().width;
  const scrollY = useScrollPosition();
  const scrollPages = Math.round((scrollY / windowHeight) * 100) / 100;
  const isMobile = windowWidth < 1024;

  let dynamic = {};
  if (!isMobile) {
    dynamic = { transform: `translate3d(0, ${((scrollPages) * 200)}px, 0)` }
  }

  return (
    <Section
      padding="top"
      largePaddingTop
      backgroundColor={backgroundColor}
      backgroundImage={(isMobile && mobileBackgroundImage) ? mobileBackgroundImage : backgroundImage}
      backgroundAlt={backgroundAlt}
      backgroundImageSrc={backgroundImageSrc}
      backgroundVideo={backgroundVideo}
      backgroundGradient={backgroundGradient}
      backgroundGradientWhite={backgroundGradientWhite}
      mobileNoBackgroundVideo={mobileNoBackgroundVideo}
      className={`${className} ${styles.showcaseHeader} ${lightOnDarkDesktop ? styles.lightOnDarkDesktop : ""}`}
      style={style}
      flexFix={flexFix}
      childrenAfter={
        <>
          {backgroundImageCustom || null}
          {caption && (
            <div className={styles.caption}>
              <Grid>
                <Col start={1} span={4}>
                  {caption}  
                </Col>
              </Grid>
            </div>
          )}
        </>
      }
      childrenBefore={
        showcaseImages && (
          <div className={styles.showcaseImages}>
            {showcaseImages}
          </div>
        )
      }
    > 
      {tag || <PageLabel to="/work/" style={{ verticalAlign: "top" }} lightOnDark={lightOnDarkDesktop}>Work</PageLabel>}
      <div className={`${styles.headerText} textMarginTop`}>
      <Grid>
          <Col start={1} span={5}>
            {title && <h1 className={`h1Biggest noMargin`}>{title}</h1>}
            {titleHtml && titleHtml}
          </Col>
        </Grid>
        <Grid>
          <Col start={1} span={widerStrapline ? 4 : 3}>
            {tagline && <p className={`largeBodyText textMarginTop`}>{tagline}</p>}
          </Col>
        </Grid>
      </div>
      {additional && additional}
    </Section>
  );
};

export default ShowcaseHeader;
